<template>
  <div class="row padd-0">
    <div class="col-12 padd-0">
      <div class="row">
        <div class="col-4" style="text-align: right; padding-right: 0">Select the CSV file:</div>
        <div class="col-8">
          <form enctype="multipart/form-data">
            <input type="file" @change="onFileChange" />
          </form>
        </div>
      </div>

      <div class="mt-4" v-if="headers.length > 0">
        <div class="row mt-2" v-for="(dt, ind) in data" :key="dt.key">
          <div class="col-5" style="text-align: right;">
            <b-input type="text" v-model="data[ind].name" disabled></b-input>
          </div>
          <div class="col-1">-></div>
          <div class="col-5">
            <b-form-select
              v-model="data[ind].value"
              @change="checkAssignment()"
              :options="headersComp"
            ></b-form-select>
          </div>
          <div
            class="col-1"
            style="align-self: center;"
            v-if="data[ind].type == 'additional'"
            @click="data.splice(ind, 1); checkAssignment()"
          >
            <b-icon-trash></b-icon-trash>
          </div>
          {{data[ind]}}
        </div>
      </div>
      <div class="row mt-4" v-if="headers.length > 0">
        <div class="col" style="text-align: left;">
          <b-button
            type="button"
            variant="outline-primary"
            size="sm"
            @click="data.push({
          key: '',
          name: '',
          value: -1,
          type: 'additional',
          folder: 'additional_data'
        }); checkAssignment()"
          >Add More...</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CsvProcess",
  components: {},
  props: {
    // rem_set: Object
  },
  data() {
    return {
      data: [
        {
          key: "userId",
          name: "Cust-No",
          value: -1
        },
        {
          key: "firstName",
          name: "First Name",
          value: -1
        },
        {
          key: "lastName",
          name: "Last Name",
          value: -1
        },
        {
          key: "make",
          name: "Make",
          value: -1
        },
        {
          key: "model",
          name: "Model",
          value: -1
        },
        {
          key: "year",
          name: "Year",
          value: -1
        },
        {
          key: "carId",
          name: "Vin",
          value: -1
        },
        {
          key: "phone",
          name: "Phone",
          value: -1
        },
        {
          key: "xdate",
          name: "Send Date",
          value: -1
        }
      ],
      fileinput: [],
      headers: []
    };
  },

  watch: {},
  computed: {
    headersComp: function() {
      let arr = [
        {
          value: -1,
          text: "select matching column"
        }
      ];
      for (let k in this.headers) {
        arr.push({
          value: k,
          text: this.headers[k],
          disabled: this.data.find(e => e.value == k)
        });
      }
      return arr;
      // return this.headers.filter(el => !);
    }
  },

  mounted() {},

  methods: {
    checkAssignment() {
      for (let i in this.data) {
        if (this.data[i].type == "additional" && this.data[i].value != -1) {
          this.data[i].name = this.headersComp.find(
            el => el.value == this.data[i].value
          ).text;

          this.data[i].key = this.data[i].name.split(` `).join("");
          this.data[i].key = this.data[i].name.split(`-`).join("_");
        }
      }

      this.$emit(
        "csvNotLoaded",
        this.data.find(el => el.value == -1) != undefined
      );

      if (this.data.find(el => el.value == -1) == undefined) {
        this.$emit("dataAssigned", this.data);
      }
    },
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createInput(files[0]);
    },
    AutoAssign() {
      this.data[0].value = this.headers.findIndex(
        h =>
          h.includes("CUSTNO") ||
          h.includes("CUST-NO") ||
          h.includes("CUST NO") ||
          h.includes("CUST_NO")
      );
      this.data[1].value = this.headers.findIndex(
        h =>
          h.includes("FIRST-NAME") ||
          h.includes("FIRST_NAME") ||
          h.includes("FIRST NAME")
      );
      this.data[2].value = this.headers.findIndex(
        h =>
          h.includes("LAST-NAME") ||
          h.includes("LAST_NAME") ||
          h.includes("LAST NAME")
      );
      this.data[3].value = this.headers.findIndex(h => h.includes("MAKE"));
      this.data[4].value = this.headers.findIndex(h => h.includes("MODEL"));
      this.data[5].value = this.headers.findIndex(h => h.includes("YEAR"));
      this.data[6].value = this.headers.findIndex(h => h.includes("VIN"));
      // this.data[7].value = this.headers.findIndex(h => h.includes("PHONE"));
    },
    EmitLoadedDate() {
      this.$emit("csvData", this.fileinput);
    },
    createInput(file) {
      var reader = new FileReader();
      var vm = this;
      reader.onload = e => {
        e;
        vm.fileinput = this.CSVToArray(reader.result);
        vm.headers = vm.fileinput[0];
        vm.EmitLoadedDate();
        vm.AutoAssign();
      };
      reader.readAsText(file);
    },
    CSVToArray(strData, strDelimiter) {
      strDelimiter = strDelimiter || ",";
      var objPattern = new RegExp(
        "(\\" +
          strDelimiter +
          "|\\r?\\n|\\r|^)" +
          '(?:"([^"]*(?:""[^"]*)*)"|' +
          '([^"\\' +
          strDelimiter +
          "\\r\\n]*))",
        "gi"
      );
      var arrData = [[]];
      var arrMatches = null;
      while ((arrMatches = objPattern.exec(strData))) {
        var strMatchedDelimiter = arrMatches[1];
        if (
          strMatchedDelimiter.length &&
          strMatchedDelimiter !== strDelimiter
        ) {
          arrData.push([]);
        }

        var strMatchedValue;
        if (arrMatches[2]) {
          strMatchedValue = arrMatches[2].replace(new RegExp('""', "g"), '"');
        } else {
          strMatchedValue = arrMatches[3];
        }
        arrData[arrData.length - 1].push(strMatchedValue);
      }
      return arrData;
    }
  }
};
</script>
<style>
.padd-0 {
  padding: 0;
}
.m-color {
  color: #266db3;
}
#lfcycle select {
  line-height: 1;
  font-size: 14px;
  padding-top: 0;
  padding-bottom: 0;
  height: 28px;
}
.vertcenter {
  align-self: center;
}
.switchlabel {
  text-align: left;
  /* width: fit-content; */
  display: inline;
  padding-right: 10px;
}
.msg-row {
  margin-bottom: 17px;
  margin-top: 20px;
}
.triger-box-title {
  text-align: left;
}
.tr-b-mt {
  margin-top: 10px;
}
.tr-main-styling {
  margin-top: 10px;
  text-align: right;
  padding-right: 10px;
}
.tr-add-styling {
  margin-top: 10px;
  text-align: left;
}
.mt--7 {
  margin-top: 7px;
}
.font-weight-bold {
  font-weight: bold;
}
</style>





